module.exports = __webpack_public_path__ + "img/empty-schedule.d1e2db6b.png";